<script setup>
import { reactiveOmit } from "@vueuse/core";
import { MenubarTrigger, useForwardProps } from "reka-ui";
import { cn } from "../../../lib/utils";

const props = defineProps({
  disabled: { type: Boolean, required: false },
  asChild: { type: Boolean, required: false },
  as: { type: null, required: false },
  class: { type: null, required: false },
});

const delegatedProps = reactiveOmit(props, "class");

const forwardedProps = useForwardProps(delegatedProps);
</script>

<template>
  <MenubarTrigger
    data-slot="menubar-trigger"
    v-bind="forwardedProps"
    :class="
      cn(
        'hover:bg-muted aria-expanded:bg-muted rounded-sm px-1.5 py-0.5 text-sm font-medium flex items-center outline-hidden select-none',
        props.class,
      )
    "
  >
    <slot />
  </MenubarTrigger>
</template>
